export const ColorScheme = {
  LIGHT: 'light',
  DARK: 'dark',
  STRUCTURE: 'structure',
}

export const PageType = {
  CATEGORY: 'category',
  TOPIC: 'topic',
  START: 'start',
  ARTICLE: 'article',
  SEARCH: 'search',
  TAG: 'tag',
  META: 'meta',
}

export const ComponentVariant = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
}
export const BackgroundVariant = {
  SAND: 'sand',
  PASTEL_GREEN: 'pastelGreen',
  PASTEL_BLUE: 'pastelBlue',
  DARK_GREEN: 'darkGreen',
}
